import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {sendMobileAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {KLARNA_CONTAINER_ID, PAYMENT_METHOD_KLARNA} from 'constants/klarna';

import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

/**
 * send analytic if Klarna is not available
 */
export const onKlarnaError = () => {
    spawnPriorityTask(() => {
        const analytic =
            __BUILD_TYPE__ === 'desktop' ? sendDesktopAnalyticsEvent : sendMobileAnalyticsEvent;

        analytic(
            CHECKOUT_PAYMENT_STEP,
            {
                message: `Error - Klarna - the script of klarna did not loaded`,
                method: PAYMENT_METHOD_KLARNA,
            },
            false,
        );
    }, 'idle');
};

/**
 * initialize Klarna script
 */
export const initKlarna = (clientToken: string, identifier: string) => {
    if (window.Klarna) {
        window.Klarna.Payments.init({client_token: clientToken});

        window.Klarna.Payments.load({
            container: `#${KLARNA_CONTAINER_ID}`,
            payment_method_category: identifier,
        });
    } else {
        onKlarnaError();
    }
};
